import { MutableRefObject, useEffect } from "react";

export const useFocusDialog = (
    headerDivRef: MutableRefObject<HTMLElement | null>,
    previouslyFocusedElement: MutableRefObject<HTMLElement | null>,
): void => {
    const previouslyFocusedElementRef = previouslyFocusedElement.current;
    useEffect(() => {
        const timeOut = window.setTimeout(() => {
            headerDivRef.current?.focus();
        }, 500);

        return (): void => {
            clearTimeout(timeOut);
            previouslyFocusedElementRef?.isConnected && previouslyFocusedElementRef?.focus();
        };
    }, [headerDivRef, previouslyFocusedElement, previouslyFocusedElementRef]);
};
